<template>
  <form class="user-token-form" @submit="handleSubmit">
    <h2 class=" text-grey-darkest my-4">Add/Edit College Admin</h2>
    <div class="row">
      <label for="user-id">Email</label>
      <input
        id="user-id"
        v-model="userEmail"
        class="userid-input"
        autofocus="true"
        type="email"
        required
        placeholder="Enter email of user"
        @blur="checkUser()"
      />
    </div>
    <div class="row">
      <label for="user-first-name">First Name</label>
      <input
        id="user-first-name"
        v-model="userFirstName"
        class="userid-input"
        type="text"
        required
        placeholder="Enter first name of user"
        :disabled="isDisabled"
      />
    </div>
    <div class="row">
      <label for="user-last-name">Last Name</label>
      <input
        id="user-last-name"
        v-model="userLastName"
        class="userid-input"
        type="text"
        required
        placeholder="Enter last name of user"
        :disabled="isDisabled"
      />
    </div>
    <div class="row">
      <label for="user-name">
        Password
        <span v-if="!new_user">(Leave blank to keep password unchanged)</span>
      </label>
      <input
        id="password"
        v-model="password"
        class="userid-input"
        type="text"
        :required="isPasswordRequired"
        placeholder="Enter random generated password to share with user"
        :disabled="isDisabled"
      />
    </div>
    <div class="row">
      <label for="select-cohort">Select Cohorts(s) to assign</label>
      <VueSelect
        id="select-cohort"
        v-model="selectedCohorts"
        class="w-full"
        label="name"
        :options="allCohorts"
        :reduce="c => c.name"
        multiple
      />
    </div>
    <div class="row text-center">
      <button
        class="p-3 shadow-md px-12 rounded-full mt-6 border-none text-white font-bold bg-green"
      >
        <span v-if="new_user">Create New User</span>
        <span v-else>Update User</span>
      </button>
    </div>
  </form>
</template>

<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"

export default {
  components: {
    VueSelect,
  },
  props: {
    email: String,
  },

  data() {
    return {
      userEmail: undefined,
      userFirstName: undefined,
      userLastName: undefined,
      password: undefined,
      allCohorts: [],
      selectedCohorts: [],
      user_details_received: false,
      new_user: true,
      isPasswordRequired: true,
    }
  },

  computed: {
    isDisabled() {
      if (!this.user_details_received) {
        return true
      }

      return false
    },
  },

  created() {
    this.fetchAllCohorts()
  },

  methods: {
    fetchAllCohorts() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}cohorts/fetch_not_archived`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          this.allCohorts = res.data.cohorts

          // if email is in props, go into edit mode
          if (this.email) {
            this.userEmail = this.email
            this.checkUser()
          }
        })
        .catch(err => {
          this.$noty.error(
            `Couldn't not get Cohorts from server, server responded with: ${err}`
          )
        })
    },

    // check for existing user
    checkUser() {
      if (this.userEmail) {
        this.axios({
          method: "get",
          url: `${siteConfig.siteURL}users/get_by_email?email=${this.userEmail}`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
          },
        })
          .then(res => {
            this.user_details_received = true

            if (res && res.status) {
              // existing user
              const user = res.data

              this.new_user = false
              this.isPasswordRequired = false

              this.userFirstName = user.first_name
              this.userLastName = user.last_name
              this.password = ""
              this.selectedCohorts = user.cohorts
            } else {
              // new user
              this.new_user = true
              this.isPasswordRequired = true
              this.userFirstName = ""
              this.userLastName = ""
              this.password = ""
              this.selectedCohorts = []
            }
          })
          .catch(err => {
            this.$noty.error(
              `Couldn't not get users from server, server responded with: ${err}`
            )
          })
      }
    },

    handleSubmit(e) {
      e.preventDefault()

      let url = `${siteConfig.siteURL}users/register_college_admin`
      if (!this.new_user) {
        url = `${siteConfig.siteURL}users/update_college_admin`
      }

      const data = {
        email: this.userEmail,
        password: this.password,
        first_name: this.userFirstName,
        last_name: this.userLastName,
        cohorts: this.selectedCohorts.map(c => c.id),
      }

      this.axios({
        method: "post",
        url,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data,
      })
        .then(res => {
          if (!res.data.status) {
            throw res.data.error_message
          }
          this.$noty.success("Successfully created College Admin user!", {
            layout: "topRight",
            theme: "relax",
          })
        })
        .catch(err => {
          this.$noty.error(`Failed creating College Admin user! ${err}`, {
            layout: "topRight",
            theme: "relax",
          })
        })
    },
  },
}
</script>
<style scoped>
.user-token-form {
  max-width: 500px;
  margin: auto;
  margin-top: 80px;
  text-align: left;
}
.user-token-form input {
  width: 100%;
  margin-bottom: 1rem;
  padding: 10px;
  border-radius: 5px;
}
.user-token-form > input:focus {
  border: 2px solid green;
}
.user-token-form label {
  font-size: 1rem;
}
.user-info-container {
  width: 600px;
  margin: auto;
  text-align: center;
}
.user-info-container > label {
  display: block;
  padding: 10px;
  font-size: 16px;
  text-align: center;
}
</style>
